export default {
  dialogMetadata: {
    formLabels: {
      allEmployees: 'Все сотрудники',
      allSpecs: 'Все специализации',
      period: 'Выберите период запуска тестов, по которым хотите получить выгрузку:',
      dateFrom: 'с',
      dateTo: 'по',
      email: 'Укажите e-mail на который будет отправлена ссылка на скачивание файла',
      addFields: 'Выберите дополнительные поля для формирования отчёта:',
      skillsType: 'Тип навыков',
      remove: 'Удалить расписание',
      set: 'Установить расписание',
      scoreCompleted: 'Оценка завершена',
      roadmapCreated: 'ИПР сформирован',
      roadmapFixed: 'ИПР зафиксирован',
      roadmapCompleted: 'ИПР завершён',
      roadmapProgress: '% реализации ИПР',
      overdueTasks: 'Просроченные задачи',
      skill: 'Компетенция',
      evaluatedEval: 'Оценка сотрудника',
      supervisorEval: 'Оценка руководителя',
      colleaguesEval: 'Оценка коллег',
      subordinatesEval: 'Оценка подчинённых',
      expertsEval: 'Оценка экспертов',
      avgSkill: 'Средняя оценка по компетенции',
      question: 'Индикатор',
      avgQuestion: 'Средняя оценка по индикатору',
      approvalByEvaluated: 'Составил окружение сотрудник',
      approvalBySupervisor: 'Согласовал окружение руководитель',
      selfScoreCompleted: 'Оценку заполнил сотрудник',
      supervisorScoreCompleted: 'Оценку заполнил руководитель',
      scoreProgress: '% прохождения оценки всеми участниками',
      user: 'Исполнитель',
      name: 'Наименование цели',
      description: 'Описание цели',
      type: 'Тип цели',
      curator: 'Руководитель/Куратор',
      selfScore: 'Оцените эффективность достижения цели',
      employeeScore: 'Оценка сотрудника',
      curatorScore: 'Оценка руководителя/куратора',
      comment: 'Комментарий по результату',
      file: 'или Файл',
      company: 'Название компании',
      website: 'Сайт компании',
      branch: 'Использовать собственные профили',
      clone: 'Клонировать общие профили',
      link: 'Название ссылки',
      employees: 'Выберите сотрудника',
      allTeam: 'Вся команда',
    },
    formPlaceholders: {
      employees: 'Поиск сотрудников по ФИО',
      specs: 'Поиск специализаций',
    },
    fileName: {
      fixedRoadmaps: 'Зафиксированные_планы_развития',
      roadmap: 'Карта развития',
      pivotExport: 'Общие_средние_оценки_по_360',
      pivotTested: 'Выгрузка_прогресса_по_360',
      gradePivotExport: 'Командная_статистика_по_360',
      usersGradePivotExport: 'Консолидированный_отчёт_по_360',
      scoreSkillsExport: 'Оценки_компетенций_по_360',
      passingExport: 'Прохождение_оценки_по_360',
    },
    titleTestSchedule: 'Период прохождения {test} 360',
    fixedRoadmaps: 'Выгрузить в excel зафиксированные планы развития',
    roadmap: 'Выгрузить в excel карту развития',
    pivotExport: 'Выгрузить в excel общие средние оценки',
    pivotTested: 'Выгрузить в excel статусы завершённости',
    gradePivotExport: 'Выгрузить в excel статистику по командам',
    usersGradePivotExport: 'Выгрузить в excel консолидированный отчёт',
    scoreSkillsExport: 'Выгрузить в excel оценку компетенций',
    passingExport: 'Выгрузить в excel прохождение оценки',
    noEmployees: 'Все сотрудники уже выбраны на роли экспертов',
    inviteByEmailButton: 'Пригласить по почте',
    invitedByEmailTitle: 'Приглашённые по почте',
    supervisorsTitle: 'Выберите руководителей',
    colleaguesTitle: 'Выберите коллег',
    subordinatesTitle: 'Выберите подчинённых',
    newTarget: 'Новая цель',
    buttons: {
      addPortfolio: 'Добавить кейс',
      deletePortfolio: 'Удалить кейс',
    },
    portfolio: 'Портфолио',
    deletePortfolio: 'Удалить портфолио?',
    changeCompany: 'Изменить компанию',
    changeSpecs: 'Изменить специализации',
    createCompany: 'Новая компания',
    editCompany: 'Редактировать компанию',
    tooltips: {
      branch: 'Компания с независимым, но пустым реестром, который наполняется с нуля',
      clone:
        'Компания с независимым реестром, но с готовым набором индикаторов, обучающих материалов и специализаций, которые можно изменить или использовать сразу',
      deleteNotification: 'Удалить оповещение',
      markAsRead: 'Отметить как прочитанное',
    },
    uploadResearch: 'Выгрузить в excel результаты исследования',
    logIn: 'Войти под другим пользователем',
    addSpecs: 'Добавить специализации',
    addSpecsDescription: 'Сначала укажите специалистов, потом выберите специализации',
    selectSpecs: 'Вы можете заменить или добавить специализацию',
    unreadNotifications: 'Новые уведомления',
    readNotifications: 'Прочитанные уведомления',
    deleteAllNotifications: 'Удалить всё',
    readAllNotifications: 'Прочитать всё',
    unread: 'Новые',
    read: 'Прочитанные',
    // messages
    successMessages: {
      removePeriod: 'Расписание успешно удалено',
      setPeriod: 'Расписание успешно установлено',
      sessionSettings: 'Настройки сеансов тестирования успешно изменены',
      createTarget: 'Новая цель успешно добавлена',
      changeTarget: 'Цель успешно изменена',
      changeCurators: 'Руководители/Кураторы успешно изменены',
      gradeTarget: 'Оценка успешно сохранена',
      moveTarget: 'Статус цели успешно изменён',
      deleteTarget: 'Цель успешно удалена',
      cancelTarget: 'Цель успешно отменена',
      createPortfolio: 'Портфолио успешно добавлено',
      deletePortfolio: 'Портфолио успешно удалено',
      changeCompany: 'Компания успешно изменена',
      changeSpecs: 'Специализации успешно изменены',
      createCompany: 'Компания успешно создана',
      createLink: 'Успешно добавлено',
      changeLink: 'Успешно изменено',
      deleteLink: 'Успешно удалено',
      changeUser: 'Успешно! Страница будет автоматически перезагружена...',
      selectSpecs: 'Специализации успешно выбраны',
      addSpecs: 'Специализации успешно добавлены',
      acceptInvitation: 'Приглашение принято',
      rejectInvitation: 'Приглашение отклонено',
      changeSettings: 'Изменения успешно сохранены',
    },
    errorMessages: {
      removePeriod: 'Не удалось удалить расписание',
      setPeriod: 'Не удалось установить расписание',
      exportFile: 'Не удалось сформировать файл',
      timeoutExpired:
        'Слишком большой объём данных. Пожалуйста, сократите период или выборку команд и повторите ещё раз.',
      sessionSettings: 'Не удалось изменить настройки сеансов тестирования',
      createTarget: 'Не удалось добавить цель',
      changeTarget: 'Не удалось изменить цель',
      changeCurators: 'Не удалось изменить руководителей/кураторов',
      gradeTarget: 'Не удалось сохранить оценку',
      moveTarget: 'Не удалось изменить статус цели',
      deleteTarget: 'Не удалось удалить цель',
      cancelTarget: 'Не удалось отменить цель',
      changeImage: 'Не удалось загрузить изображение',
      createPortfolio: 'Не удалось добавить портфолио',
      deletePortfolio: 'Не удалось удалить портфолио',
      changeCompany: 'Не удалось изменить компанию',
      changeSpecs: 'Не удалось изменить специализации',
      createLogo: 'Не удалось загрузить логотип',
      changeLogo: 'Не удалось изменить логотип',
      createCompany: 'Не удалось создать компанию',
      changeDashboard: 'Не удалось изменить видимость блоков на странице «Мой профиль»',
      'ERROR:INN_CONFLICT': 'Компания с таким ИНН уже существует',
      createLink: 'Не удалось добавить ссылку',
      changeLink: 'Не удалось изменить ссылку',
      deleteLink: 'Не удалось удалить ссылку',
      changeUser: 'Не удалось войти под другим пользователем',
      selectSpecs: 'Не удалось выбрать специализации',
      addSpecs: 'Не удалось добавить специализации',
      acceptInvitation: 'Не удалось принять приглашение',
      rejectInvitation: 'Не удалось отклонить приглашение',
      changeNotification: 'Не удалось отметить прочитанным уведомление',
      changeNotifications: 'Не удалось отметить прочитанными уведомления',
      deleteNotification: 'Не удалось удалить уведомление',
      deleteNotifications: 'Не удалось удалить уведомления',
      getVariables: 'Не удалось получить переменные',
      getTemplate: 'Не удалось получить превью письма',
      getSettings: 'Не удалось получить настройки',
      changeSettings: 'Не удалось сохранить изменения',
    },
    infoMessages: {
      createTarget: {
        user: 'После создания, цель будет отправлена на согласование руководителю',
        curator: 'Цель будет отправлена исполнителю в статусе «Согласована»',
      },
      approveTarget:
        'Цель ещё не была согласована руководителем/куратором, вы действительно хотите согласовать?',
      exportFile:
        'Формирование файла может занять некоторое время. Пожалуйста, не закрывайте окно и дождитесь, пока сформированный файл будет загружен.',
      exportFileAsync:
        'Формирование файла займет некоторое время, как только он будет готов, вы получите письмо со ссылкой на его скачивание.',
    },
    // dialogs
    expertsByEmailDialog: {
      supervisors: {
        title: 'Пригласить руководителя по почте',
        deleteButton: 'Удалить руководителя',
        addButton: 'Добавить руководителя',
      },
      colleagues: {
        title: 'Пригласить коллег по почте',
        deleteButton: 'Удалить коллегу',
        addButton: 'Добавить коллегу',
      },
      subordinates: {
        title: 'Пригласить подчинённых по почте',
        deleteButton: 'Удалить подчинённого',
        addButton: 'Добавить подчинённого',
      },
    },
    reEvalLockOfTests360Dialog: {
      subtitle:
        'Здесь вы можете закрыть или открыть сеансы тестирования для пользователей в созданных тестах в рамках',
      caption: {
        team: 'текущей команды',
        company: 'всей компании',
      },
      description:
        '<p>Если выбрать вариант «Закрыть всё», то все тесты созданные до момента настройки, будут не доступны для перепрохождения, т.е. пользователи не смогут изменить свои ответы.</p><p>Если выбрать вариант «Открыть всё», то все тесты созданные до момента настройки, будут доступны для перепрохождения по ссылке из письма, т.е. пользователи смогут изменить свои ответы столько раз, сколько пожелают.</p>',
      confirmDialog: {
        open: {
          title: 'Открыть сеансы?',
          text: 'Все сеансы тестирования будут открыты, пользователи смогут изменить свои ответы в тесте по ссылке из письма. Вы уверены?',
          button: 'Да, открыть',
        },
        close: {
          title: 'Закрыть сеансы?',
          text: 'Все сеансы тестирования будут закрыты, пользователи не смогут изменить свои ответы в тесте. Вы уверены?',
          button: 'Да, закрыть',
        },
      },
    },
    emailSettingsDialog: {
      title: {
        plural: 'Редактирование писем',
        single: 'Редактировать письмо',
      },
      description: 'Изменения будут применимы для всех оценок',
      branding: {
        colorBtn: 'Цвет кнопки',
        colorBtnText: 'Цвет текста на кнопке',
      },
      formLabels: {
        subject: 'Тема письма',
        greeting: 'Приветствие',
        text: 'Текст',
        link: {
          title: 'Текст',
          url: 'URL',
        },
      },
    },
    exportRoadmaps360Dialog: {
      title: {
        fixedRoadmaps: 'Выгрузить в excel зафиксированные планы развития',
        massRoadmap: 'Выгрузить в excel карту развития',
      },
      formLabels: {
        allEmployees: 'Все сотрудники',
        allSpecs: 'Все специализации',
        period: 'Выберите период запуска тестов, по которым хотите получить выгрузку:',
        email: 'Укажите e-mail на который будет отправлена ссылка на скачивание файла',
        addFields: 'Выберите дополнительные поля для формирования отчёта:',
        skillsType: 'Тип навыков',
        scoreCompleted: 'Оценка завершена',
        roadmapCreated: 'ИПР сформирован',
        roadmapFixed: 'ИПР зафиксирован',
        roadmapCompleted: 'ИПР завершён',
        roadmapProgress: '% реализации ИПР',
        overdueTasks: 'Просроченные задачи',
      },
      formPlaceholders: {
        employees: 'Поиск сотрудников по ФИО',
        specs: 'Поиск специализаций',
      },
      fileName: {
        fixedRoadmaps: 'Зафиксированные_планы_развития',
        massRoadmap: 'Карта развития',
      },
    },
    addExpertGroupsTest360Dialog: {
      title: 'Новая группа',
      description: 'Любые изменения групп будут применены ко всем оценкам в этом назначении',
      formLabels: {
        groups: 'Выберите название группы',
      },
      formRules: {
        maxLength: 'Больше {count} добавить нельзя',
      },
    },
    evaluatedGroupDialog: {
      title: 'Справочник групп',
      subTitle: 'Список групп оценивающих, доступных для запуска в оценке 360',
      noGroups: 'Список групп пуст, для добавления нажните на кнопку «Добавить»',
      labelSearch: 'Поиск по группам',
      successMessage: 'Группа успешно добавлена',
      errorMessage: 'Ошибка при добавлении группы',
    },
    addEvaluatedGroupDialog: {
      title: 'Новая группа',
      rules: {
        matchItem: 'Группа с таким названием была добавлена в справочник ранее',
        maxLength: 'Длина не должна превышать 50 символов',
      },
      labelForm: 'Название группы*',
      successMessage: 'Группа успешно добавлена',
      errorMessage: 'Ошибка при добавлении группы',
    },
    inviteExpertsByEmailDialog: {
      title: 'Пригласить участника по почте',
    },
    selectExpertsTest360Dialog: {
      noEmployees: 'Все сотрудники уже выбраны на роли экспертов',
      inviteByEmailButton: 'Пригласить по почте',
      invitedByEmailTitle: 'Приглашённые по почте',
      title: 'Список участников группы «{name}»',
    },
    selectEmployeesDialog: {
      title: 'Выбор сотрудников',
    },
    createTargetDialog: {
      title: 'Новая цель',
      formLabels: {
        user: 'Исполнитель',
        name: 'Наименование цели',
        description: 'Описание цели',
        type: 'Тип цели',
        curator: 'Руководитель/Куратор',
        selfScore: 'Оцените эффективность достижения цели',
        employeeScore: 'Оценка сотрудника',
        curatorScore: 'Оценка руководителя/куратора',
        comment: 'Комментарий по результату',
      },
      tooltips: {
        saveForScoreStatus: 'Для сохранения изменений необходимо поставить оценку',
        progress: 'Укажите процент выполнения цели в числовом выражении',
      },
    },
    createTeamReportDialog: {
      createReportDescription: {
        default: 'Для формирования командного отчёта выберите команду из списка',
        tests360: 'Для формирования командного отчёта установите нужные фильтры',
      },
      reportIsUnavailable: {
        tests360: 'Нет пройденных тестов 360 для формирования отчёта',
        personal: 'Нет пройденных тестов для формирования отчёта',
      },
      formLabels: {
        period: 'Период оценки',
        specialization: 'Выберите специализацию',
        employees: 'Выберите участников',
        composition: 'Состав оценки',
      },
    },
    // confirm dialogs
    confirmDeleteTarget: {
      title: 'Удалить цель?',
    },
    confirmCancelTarget: {
      title: 'Отменить цель?',
      button: 'Да, отменить',
      buttonCancel: 'Не отменять',
    },
    //
  },
};
